var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
// removed import of scss-style
import NotationButton from '../notation-button/NotationButton';
import { observer } from 'mobx-react';
class NotationCombo extends React.Component {
    render() {
        const _a = this.props, { className, title, body } = _a, rest = __rest(_a, ["className", "title", "body"]);
        return (React.createElement("div", { className: 'NotationCombo' },
            React.createElement(NotationButton, Object.assign({ notationTitle: title, notationBody: body, className: className }, rest))));
    }
}
export default observer(NotationCombo);
